import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ExternalLink } from "lucide-react";

export const pinAreaMapUrl = (pincode, area) =>
  /^[1-9]\d{5}$/.test(pincode || "") ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([area, pincode, "India"].filter(Boolean).join(" "))}` : "";

// Shop has no saved exact coordinates: say so honestly, show what is known (address / area + PIN), offer an area-only map.
export default function ShopAreaNotice({ vendor }) {
  const area = vendor.location || "";
  const areaUrl = pinAreaMapUrl(vendor.pincode, area);
  return (
    <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600 min-w-0 break-words" data-testid="vendor-map-unavailable">
      <div className="flex items-start gap-2">
        <MapPin className="w-4 h-4 text-slate-400 mt-0.5 flex-shrink-0" />
        <div className="min-w-0">
          <div className="font-semibold text-slate-800" data-testid="vendor-exact-location-missing">Shop ki exact map location saved nahi hai</div>
          {vendor.pincode && <div className="text-xs mt-0.5" data-testid="vendor-area-pin">{area ? `${area} · ` : ""}PIN {vendor.pincode}</div>}
          {vendor.address
            ? <div className="text-xs text-slate-500 mt-1">Directions saved address se khulenge — exact jagah ke liye Call/WhatsApp karein.</div>
            : <div className="text-xs text-slate-500 mt-1">Sahi pata jaanne ke liye Call/WhatsApp karein.</div>}
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {areaUrl && (
          <a href={areaUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white hover:border-emerald-400 px-3 py-1.5 text-xs font-semibold text-slate-700 min-h-[36px]" data-testid="vendor-pin-area-map">
            <ExternalLink className="w-3.5 h-3.5" /> PIN area map par dekhein
          </a>
        )}
        {vendor.is_owner && (
          <Link to={`/vendor?tab=shop&focus=location&shop=${encodeURIComponent(vendor.id || "")}`} className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-900 px-3 py-1.5 text-xs font-semibold min-h-[36px]" data-testid="vendor-owner-set-location">
            <MapPin className="w-3.5 h-3.5" /> Set location
          </Link>
        )}
      </div>
      {areaUrl && <div className="text-[11px] text-slate-500 mt-2" data-testid="vendor-pin-area-note">Yeh map sirf PIN ka area dikhata hai, dukaan ki exact jagah nahi.</div>}
    </div>
  );
}
